import { Link } from 'react-router-dom';

import camping from '../../assets/adventure-1851092_640.jpg';
import consulting from '../../assets/consulting-3031678_640.jpg';
import keys from '../../assets/key-791390_640.jpg';

function HeaderSection2() {
  const articles = [
    {
      image: keys,
      category: '#PROPRIÉTAIRES',
      title: 'Garer votre voiture là où il y a de la demande',
      description:
        'Découvrez comment identifier les zones où votre véhicule peut être le plus recherché.',
    },
    {
      image: consulting,
      category: '#MOOVICAR',
      title: "Moovicar et FatahConnect s'associent",
      description: 'Une nouvelle collaboration pour développer une mobilité plus accessible.',
    },
    {
      image: camping,
      category: '#INSPIRATIONS',
      title: '7 idées géniales de road trip en Van aménagé',
      description: 'Des idées de destinations pour prendre la route autrement.',
    },
  ];

  return (
    <section className="mc-news-section">
      <div className="container mc-container">
        <div className="mc-section-heading mc-section-heading-row">
          <div>
            <span className="mc-section-kicker">LE JOURNAL MOOVICAR</span>

            <h2>
              Inspiration,
              <span>mobilité & conseils.</span>
            </h2>
          </div>

          <Link to="#" className="mc-view-all">
            Tout voir
            <i className="bi bi-arrow-up-right" />
          </Link>
        </div>

        <div className="mc-news-grid">
          {articles.map((article) => (
            <Link to="#" className="mc-news-card" key={article.title}>
              <div className="mc-news-image">
                <img src={article.image} alt={article.title} />

                <span>{article.category}</span>
              </div>

              <div className="mc-news-content">
                <h3>{article.title}</h3>

                <p>{article.description}</p>

                <span className="mc-news-link">
                  Lire l'article
                  <i className="bi bi-arrow-up-right" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeaderSection2;
